const {jQuery: $, mozartData} = window;

let app = {

  init: function () {

    app.variationAttributeCheckboxSelector('pa_matratze-continuous', 20);
  },

  /**
   * Replace attribute selector select to checkbox. Attribute should have 'yes' and 'no' options.
   *
   * @param attrId
   */
  variationAttributeCheckboxSelector: function (attrId, price) {

    let $select = $('select#' + attrId);

    if (
      $select.length === 0 ||
      $select.find('option[value="no"]').length === 0 ||
      $select.find('option[value="yes"]').length === 0
    ) {
      return;
    }

    let $row = $select.closest('tr'),
      label = $row.find('td.label > label').text();

    let $wrapper = $('<label class="mozart-checkbox-attribute-selector">'),
      $checkbox = $('<input type="checkbox">');

    $wrapper.append($checkbox, label);

    if (price) {
      $wrapper.append('<span>' + price + mozartData.currencySymbol + '</span>')
    }

    $row.find('td.label').attr('style', 'display:none !important');
    $select.hide();

    $select.after($wrapper);

    if ($select.val() === '') {
      $select.val('no').change();
    }

    $checkbox.prop('checked', $select.val() === 'yes');

    $checkbox.change(function () {
      $select.val($(this).is(':checked') ? 'yes' : 'no').change();
    });

    $select.change(function () {
      if ($(this).val() === '') {
        $checkbox.prop('checked', false).change();
      }
    });
  }
};

// Init App.
$(app.init);
